import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../store/actionCreators/dialog';
const JoinUnionForm =() => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [unionId, setUnionId] = useState('');

    const joinUnion = () => {
        if( !!unionId ) {
            dispatch(openDialog('unionConfirmation', {unionId: unionId}))
        }
    };

    return (
        <React.Fragment>
            <div className="field">
                {t('dialog.joinLabel')}
                <label><input type="number" onChange={ e=>setUnionId(e.target.value) } /></label>
            </div>
            <div className="dialogConfirmBox">
                <button className="primary" onClick={joinUnion}>{t('button.join')}</button>
            </div>
        </React.Fragment>
    );
};

export default JoinUnionForm;
